<template>
  <div class="collaboration">
    <!-- collaboration Tit Starts -->
    <section class="collaboration-tit">
      <div class="collaboration-tit-content">
        International partner universities
      </div>
    </section>
    <!-- collaboration Tit End -->


    <!-- collaboration List Starts -->
    <section class="collaboration-list">
      <div class="container">
        <div class="row">
          <template v-for="(item,index) in collaborationList">
          <div class="col-md-4" :key="index+'coll'">
              <div class="collaboration-list-item wow flipInY"  @click="toDetail(item.id)" >
                <div class="collaboration-list-item-img">
                  <img :src="item.img" alt="school">
                </div>
                <div class="collaboration-list-item-logo">
                  <img :src="item.logo" alt="school">
                </div>
                <div class="collaboration-list-item-content" >
                  <div class="collaboration-list-item-content-box">
                    <div class="collaboration-list-item-content-tit">{{ item.title }}</div>
                    <div class="collaboration-list-item-content-dec">
                      <p style="margin-bottom: 0;">
                        {{ item.desc }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

          </div>
          </template>
        </div>
      </div>

    </section>
    <!-- collaboration List End -->

    <section class="collaboration-content">
      <div class="row" style="margin-left: 0;margin-right: 0;">
        <div class="col-lg-10 col-md-10" style="padding-left: 0;padding-right: 0;">
          <div class="collaboration-content-topBox">
              <div class="collaboration-content-topBox-tit">International activities</div>
              <div class="row"  style=" margin-left: 0;margin-right: 0; clear: both;">
                <div class="col-lg-4 collaboration-content-topBox-item wow bounceIn" style="padding-left: 0;padding-right: 0;">
                    <div class="collaboration-content-topBox-item-top" style="height: 50%" :style="{ '--bgColor': '#DF7E49' }" >
                      <div class="collaboration-content-topBox-item-top-nr">
                        <div class="tem-top-nr-text">China Europe Civilization Forum</div>
                        <div class="tem-top-nr-btn">
                          <a @click="router('1','collaborationDetails')" class="genric-btn success-border circle">More …</a>
                        </div>

                      </div>
                    </div>
                  <div class="collaboration-content-topBox-item-top" style="height: 50%" :style="{ '--bgColor': '#810900' }" >
                    <div class="collaboration-content-topBox-item-top-nr">
                      <div class="tem-top-nr-text">China-France Higher Education Forum</div>
                      <div class="tem-top-nr-btn">
                        <a @click="router('2','collaborationDetails')"  class="genric-btn success-border circle">More …</a>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="col-lg-4 collaboration-content-topBox-item wow bounceIn" style="padding-left: 0;padding-right: 0;">
                  <div class="collaboration-content-topBox-item-top" :style="{ '--bgColor': '#E29B74' }" >
                    <div class="collaboration-content-topBox-item-top-nr">
                      <div class="tem-top-nr-text">International Academic Conference on Global Evolution of Population Aging from an Interdisciplinary Perspective</div>
                      <div class="tem-top-nr-btn">
                        <a @click="router('3','collaborationDetails')"  class="genric-btn success-border circle">More …</a>
                      </div>

                    </div>
                  </div>
                  <div class="collaboration-content-topBox-item-bot">
                  </div>
                </div>

                <div class="col-lg-4 collaboration-content-topBox-item wow bounceIn" style="padding-left: 0;padding-right: 0;">
                  <div class="collaboration-content-topBox-item-top" style="height: 50%;" :style="{ '--bgColor': '#611D1D' }" >
                    <div class="collaboration-content-topBox-item-top-nr">
                      <div class="tem-top-nr-text">Policy Forum in Asia</div>
                      <div class="tem-top-nr-btn">
                        <a @click="router('4','collaborationDetails')"  class="genric-btn success-border circle">More …</a>
                      </div>

                    </div>
                  </div>
                  <div class="collaboration-content-topBox-item-top" style="height: 50%;" :style="{ '--bgColor': '#DB7547' }" >
                    <div class="collaboration-content-topBox-item-top-nr">
                      <div class="tem-top-nr-text">World Congress of Sinology</div>
                      <div class="tem-top-nr-btn">
                        <a @click="router('5','collaborationDetails')"  class="genric-btn success-border circle">More …</a>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div class="collaboration-content-bottomBox">
            <div class="collaboration-content-bottomBox-box">
            <div class="collaboration-content-bottomBox-tit">International Exchange and Cooperation Programs</div>
            <div class="row" style="margin-left: 0;margin-right: 0; clear: both;">
              <div class="col-lg-4 collaboration-content-topBox-item" style="padding-left: 0;padding-right: 0;">
                <div class="collaboration-content-botBox-item-bot2 wow bounceIn" :style="{ '--bgColor': '#DF7E49' }" >
                  <div class="collaboration-content-topBox-item-top-nr">
                    <div class="tem-bot-nr-img">
                      <img src="http://en.sc.ruc.edu.cn/static/images/collaboration/png9.png" alt="collaboration" />
                    </div>
                  </div>
                </div>
                <div class="collaboration-content-topBox-item-bot">

                </div>
              </div>

              <div class="col-lg-4 collaboration-content-topBox-item" style="padding-left: 0;padding-right: 0;">
                <div class="collaboration-content-botBox-item-bot2 wow bounceIn" :style="{ '--bgColor': '#810900' }" >
                  <div class="collaboration-content-topBox-item-top-nr">
                    <div class="tem-bot-nr-text">
                      China-Europe European Law Program
                    </div>
                    <div class="tem-bot-nr-btn">
                      <a @click="router('6','internationalDetails')"  class="genric-btn success-border circle">More …</a>
                    </div>

                  </div>
                </div>
                <div class="collaboration-content-topBox-item-bot">
                  <div class="collaboration-content-topBox-item-bot-lf" style="background-color: #E25A6A;"></div>
                </div>
              </div>

              <div class="col-lg-4 collaboration-content-topBox-item" style="padding-left: 0;padding-right: 0;">
                <div class="collaboration-content-botBox-item-bot2 wow bounceIn" :style="{ '--bgColor': '#D75C26' }" >
                  <div class="collaboration-content-topBox-item-top-nr">
                    <div class="tem-bot-nr-text">
                      International Exchange Program
                    </div>
                    <div class="tem-bot-nr-btn">
                      <a @click="router('7','internationalDetails')"  class="genric-btn success-border circle">More …</a>
                    </div>

                  </div>
                </div>
                <div class="collaboration-content-topBox-item-bot">
                  <div class="collaboration-content-topBox-item-bot-lf" style="background-color: #B02541;"></div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-2" style="padding-left: 0;padding-right: 0;">
          <div class="collaboration-content-rt"></div>
        </div>
      </div>
    </section>

    <div class="bottom-empty">

    </div>
  </div>
</template>
<script>
import router from '../router'

export default {
  data () {
    return {
      collaborationList: [
        {
          id: '1',
          bgColor: '#8B2929',
          title: 'Sorbonne University',
          img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/jpg1.jpg',
          logo: 'http://en.sc.ruc.edu.cn/static/images/collaboration/png4.png',
          desc: ''
        },
        {
          id: '2',
          bgColor: '#DEBD9E',
          title: 'Paul-Valéry Montpellier 3',
          img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/jpg2.jpg',
          logo: 'http://en.sc.ruc.edu.cn/static/images/collaboration/png5.png',
          desc: 'University'
        },
        {
          id: '3',
          bgColor: '#DF7E49',
          title: 'KEDGE Business School',
          img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/jpg3.jpg',
          logo: 'http://en.sc.ruc.edu.cn/static/images/collaboration/png6.png',
          desc: ''
        }
      ]
    }
  },
  methods: {
    router (id, url) {
      router.push({
        path: '/' + url,
        query: {
          id: id
        }
      })
    },
    toDetail (id) {
      router.push({
        path: '/universitiDetails',
        query: {
          id: id
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// Collaboration.vue?6d462f6e